import { LoginRes } from '@/types/user'
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { logout, fetchUserDetail, getUserAuth } from '@/api/users'
import { getSessionStorage, setSessionStorage } from '@/utils/tools'
import { Message } from 'element-ui'
import { CommonMudule } from './common'
import { investRouter } from '@/router/subRouter/investRouter'
import { manageRouter } from '@/router/subRouter/manageRouter'
import { errorRouter } from '@/router/subRouter/errorRouter'
import { constRoutes } from '@/router/subRouter/constRoutes'
import { tenantRouter } from '@/router/subRouter/tenantRouter'
import { boardManage } from '@/router/subRouter/boardManage'
import { AuthRoute } from '@/types/axios'
import { cloneDeep } from 'lodash'
import store from '@/store'

const initUser: LoginRes = {
  id: '',
  tenantId: "",
  createTime: '',
  createBy: null,
  createByName: null,
  deleted: false,
  username: '',
  name: '',
  flag: false,
  mobile: '',
  email: '',
  deptId: null,
  deptCode: null,
  token: '',
  lastLoginTime: '',
  userRoles: null,
  deptName: null,
  avatar: null,
  positionName: null,
  admin: true,
  roleManagerType: null
}

let userInfo: LoginRes
let tenantId = ""
const localInfo = window.sessionStorage.getItem('userData')
if (localInfo) {
  userInfo = JSON.parse(localInfo)
  tenantId = userInfo.tenantId
} else {
  userInfo = initUser
}

export interface UserState {
  token: string | null;
  name: string;
  introduction: string;
  roles: string[];
  userInfo: LoginRes;
  tenantId: string
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements UserState {
  public token = sessionStorage.getItem('token')
  public authConfig = getSessionStorage('authConfig') || []
  // public authConfig = []
  public name = ''
  public introduction = ''
  public roles: string[] = []
  public userInfo: LoginRes = userInfo
  public asyncRoute: any[] = []
  public investRoute: any[] = []
  public tenantId = tenantId
  public userAuthObj = {
    1: '全局管理员',
    2: '管理员-投资业务',
    3: '管理员-保险业务',
    4: '用户'
  }

  @Mutation
  public SET_TOKEN (token: string) {
    this.token = token
    window.sessionStorage.setItem('token', token)
  }

  @Mutation
  public SET_USERDATA (userData: LoginRes) {
    console.log('step1-2')
    if(!userData.avatar) {
      userData.avatar = require('@/assets/images/author_img.png')
    }
    this.userInfo = userData
    this.tenantId =  userData.tenantId
    window.sessionStorage.setItem('userData', JSON.stringify(userData))
    window.sessionStorage.setItem('tenantId', userData.tenantId)
  }

  @Mutation
  public SET_USERDATA_ITEM<T, K extends keyof LoginRes> (keyVal: {field: K; value: any}) {
    const { field, value } = keyVal
    this.userInfo[field] = value
    this.tenantId =  this.userInfo.tenantId
    window.sessionStorage.setItem('userData', JSON.stringify(this.userInfo))
    window.sessionStorage.setItem('tenantId', this.userInfo.tenantId)
  }

  @Mutation
  private SET_ROLES (roles: string[]) {
    this.roles = roles
  }

  @Mutation
  private SET_AUTH_CONFIG (data: []) {
    setSessionStorage('authConfig', data)
    this.authConfig = [...data]
  }

  @Mutation
  private SET_ASYNC_ROUTER (data: any[]) {
    this.asyncRoute = data
    console.log('SET_ASYNC_ROUTER  data', data)
  }

  @Mutation
  private SET_INVEST_ROUTER (data: any[]) {
    this.investRoute = data
    console.log('SET_INVEST_ROUTER  data', data)
  }

  @Action
  public ResetToken () {
    this.SET_TOKEN('')
    this.SET_ROLES([])
    this.SET_ASYNC_ROUTER([])
    this.SET_INVEST_ROUTER([])
  }

  @Action
  public filterasyncRoute (route: AuthRoute[]) {
    const r = route.filter((item: AuthRoute) => {
      if (this.authConfig.includes(item.resourceId)) {
        if (item.children) {
          item.children = item.children.filter((child: any) => {
            // eslint-disable-next-line no-prototype-builtins
            if (child.hasOwnProperty('resourceId')) {
              if (this.authConfig.includes(child.resourceId)) {
                return true
              }
            } else {
              return true
            }
          })
        }
        return true
      }
    })
    return r
  }

  // @Action
  // public filterasyncRoute(route:AuthRoute[]) {
  //   const filterRoute = (route:AuthRoute[]) => {
  //     return route.filter((child: AuthRoute) => {
  //       if (child.hasOwnProperty('resourceId')) {
  //         if (this.authConfig.includes(child.resourceId)) {
  //           return true
  //         } else {
  //           return false
  //         }
  //       } else {
  //         return true
  //       }
  //     }).map((item:AuthRoute) => {
  //       if (item.children) {
  //         filterRoute(item.children)
  //       }
  //       return item
  //     })
  //   }
  //   const ret = filterRoute(route)
  //   console.log('ret11', ret)
  //   return ret
  // }

  @Action
  public UserDetailAction (parmas?: string) {
    console.log('step1-1')
   return  new Promise((resolve, reject) =>{
      fetchUserDetail({
        userId: parmas || this.userInfo.id
      }).then((res) => {
        if (res.success && res.statusCode === 0) {
          this.SET_USERDATA(res.data)
        } else {
          Message({
            message: res.errorMsg,
            type: 'error',
            duration: 5 * 1000
          })
        }
        resolve(true)
      })
    })


  }

  @Action
  public GetUserAuthAction () {
    return new Promise<void>(resolve => {
      getUserAuth()
        .then(res => {
          if (res.statusCode === 0 && res.data) {
            this.SET_AUTH_CONFIG(res.data)
            resolve()
          }
        })
    })
  }

  @Action
  public sortRoute (route: AuthRoute[]): AuthRoute[] {
    console.log('SortRoute route', route)
    return route.sort((a: AuthRoute, b: AuthRoute) => {
      return a.meta.sort - b.meta.sort
    })
  }

  @Action
  public GenerateRoutes () {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<void>(async (resolve) => {
      const originRouter = [...investRouter, ...tenantRouter, ...manageRouter]
      const ret = await this.filterasyncRoute(cloneDeep(originRouter))
      let fullRoute = [...constRoutes, ...ret, ...errorRouter]
      fullRoute = await this.sortRoute(cloneDeep(fullRoute))
      if(window.sessionStorage.getItem("newbanker") === "google"){
        fullRoute = [...fullRoute, ...boardManage]
      }
      this.SET_ASYNC_ROUTER(fullRoute)

      let investRes = await this.filterasyncRoute(cloneDeep(investRouter))
      investRes = await this.sortRoute(cloneDeep(investRes))
      this.SET_INVEST_ROUTER(investRes)
      resolve()
    })
  }

  @Action
  public async LogOut () {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!')
    }
    await logout()
    this.SET_TOKEN('')
    this.SET_USERDATA(initUser)
    this.SET_ROLES([])
    this.SET_AUTH_CONFIG([])
    this.SET_ASYNC_ROUTER([])
    this.SET_INVEST_ROUTER([])
    CommonMudule.SET_CUSTOMERID({
      id: '',
      customerName: ' '
    })
    window.sessionStorage.clear()
    Message({
      message: '退出登录',
      type: 'success',
      duration: 5 * 1000
    })
  }
}

export const UserModule = getModule(User)
